module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/inner-6-c8502e943efd378894d85948fe40e523.jpg";